import user from '../../Basics/User'
const god = {
  templateName: 'cardTemplateVip04',
  imgSrc: 'card/template/vip01/cardTemplateVip04.png',
  desc: 'logo 模板',
  category: 'card',
  vipGrade: 1,
  attr: {
    textColor: {
      type: 'color',
      id: '',
      label: '文本颜色',
      value: '#fff'
    },
    LogoImage: {
      type: 'image',
      id: '',
      label: 'LOGO图片',
      value: 'icon/logo.png'
    },
    bgImage: {
      type: 'image',
      id: '',
      label: '背景图片',
      value: 'card/material/1.jpg'
    },
    modelSrc: {
      type: 'model',
      id: '',
      label: '上传模型',
      value: 'model/beetle.gltf'
    }
  }
}
god.attr = Object.assign(god.attr, user)
export default god
